const STEPS = [
  {
    n: "01",
    name: "Discover",
    body: "We sit down with you (or jump on a call), map your current funnel, tech stack and the manual work eating your team's time.",
    out: "Audit + opportunity map",
  },
  {
    n: "02",
    name: "Design",
    body: "We propose the smallest set of changes with the biggest impact — and lock scope, cost and timelines before any work starts.",
    out: "Proposal + roadmap",
  },
  {
    n: "03",
    name: "Build",
    body: "Websites, stores, automations and CRM go live in tight 2–6 week sprints. You see progress every Friday.",
    out: "Shipped systems",
  },
  {
    n: "04",
    name: "Grow",
    body: "Once the foundation is live, we run growth: SEO, ads, lifecycle and continuous optimisation against revenue targets.",
    out: "Compounding revenue",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-20 md:py-32 bg-[color:var(--bg-soft)]/60 border-b hairline relative"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-8 items-end mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-7">
            <div className="section-label mb-4">
              <span className="dot" /> How we work
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] text-balance">
              A clear, calm{" "}
              <span className="font-serif-accent italic font-normal">
                4-step
              </span>{" "}
              engagement.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-10">
            <p className="text-[color:var(--ink-2)]">
              No mystery, no padding, no surprise invoices. You always know
              exactly what's being built, why, and what it will return.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-[color:var(--hair)] border hairline rounded-lg overflow-hidden">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="p-7 md:p-8 bg-[color:var(--bg)] hover:bg-white transition-colors flex flex-col min-h-[260px]"
            >
              <div className="font-display text-5xl md:text-6xl tracking-tighter font-bold text-[color:var(--accent)]">
                {s.n}
              </div>
              <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight mt-4">
                {s.name}
              </h3>
              <p className="text-sm md:text-base text-[color:var(--ink-2)] mt-3 leading-relaxed">
                {s.body}
              </p>
              <div className="mt-auto pt-6 text-[11px] uppercase tracking-[0.22em] text-[color:var(--ink-2)]">
                Output · <span className="text-[color:var(--ink)]">{s.out}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
